import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import { candidatePayments, taskPayment } from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const CandidatePayment = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [payments, setPayment] = useState([]);
  const [btnloading, setBtnLoading] = useState(false);
  const [btnloadingIndex, setBtnLoadingIndex] = useState(null);

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchPayments = async () => {
      try {
        setLoading(true);
        const response = await candidatePayments();
        console.log(response);

        // ✅ FIX: Extract array properly
        setPayment(response.data?.approvedPaymentList || []);
      } catch (err) {
        console.error("Error fetching Payments:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, [location.state]);

  const handlePayment = async (applicationId, index) => {
    try {
      setBtnLoadingIndex(index);

      const body = { isPaid: true };
      const response = await taskPayment(applicationId, body);

      toast.success(response.message);

      const refreshed = await candidatePayments();
      setPayment(refreshed.data?.approvedPaymentList || []);
    } catch (err) {
      console.error("Payment error:", err);
      // toast.error(err.response?.data?.message);
    } finally {
      setBtnLoadingIndex(null);
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Candidate Payment</h2>
          </div>

          <div className="row">
            {loading ? (
              <div className="text-center w-100 my-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : payments.length === 0 ? (
              <div className="col-12">
                <div className="alert alert-info text-center">
                  No Payments found.
                </div>
              </div>
            ) : (
              payments.map((payment, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                  <div className="profile-card">
                    <h5 className="card-title">{payment.jobSeekerName}</h5>
                    <p>{payment.jobTitle}</p>
                    <hr />
                    <p>
                      Total Tasks - <strong>{payment.totalTasks}</strong>
                    </p>
                    <p>
                      Approved Tasks - <strong>{payment.approvedTasks}</strong>
                    </p>
                    <p>
                      Total Hours - <strong>{payment.totalHours}</strong>
                    </p>
                    <p>
                      Total Amount - <strong>₹{payment.totalAmount}</strong>
                    </p>
                    <hr />

                    <button
                      type="button"
                      className="normalbtn"
                      onClick={() =>
                        handlePayment(payment.jobApplicationId, index)
                      }
                    >
                      {btnloadingIndex === index ? (
                        <span>
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ marginRight: "8px" }}
                          ></i>
                          Processing...
                        </span>
                      ) : (
                        "Make Payment"
                      )}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CandidatePayment;
